/**
 * created by
 *
 */
import React, {Component} from 'react';
import BaseComponent from "../../../../base/BaseComponent";
import {uuid} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";

const config = [
        [{
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.publisher&&this.state.propsData.publisher.userName", // 值所在位置
            label: "发布人", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }, {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.publisher&&this.state.propsData.publisher.deptObj&&this.state.propsData.publisher.deptObj.name", // 值所在位置
            label: "发布部门", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.title", // 值所在位置
            label: "任务名称", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }, {
            componentType: "ViewTime", // UI类型
            value: "this.state.propsData.startTime", // 值所在位置
            label: "活动时间", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.place", // 值所在位置
            label: "活动地点", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }, {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.sponsor", // 值所在位置
            label: "主办单位", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.contacts", // 值所在位置
            label: "活动广告", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }, {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.contactsWay", // 值所在位置
            label: "联系方式", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "ViewTime", // UI类型
            value: "this.state.propsData.createTime", // 值所在位置
            label: "我的角色", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }, {
            componentType: "ViewTime", // UI类型
            value: "this.state.propsData.replyTime", // 值所在位置
            label: "回稿时间", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "TaskDetail", // UI类型
            value: "this.state.propsData.content", // 值所在位置
            label: "任务内容", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "Attachment", // UI类型
            value: "this.state.propsData.attachments", // 值所在位置
            label: "上传附件", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "ReleaseMedia", // UI类型
            value: "this.state.propsData.medias", // 值所在位置
            label: "拟发平台", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }],
        [{
            componentType: "TaskReporter", // UI类型
            value: "this.state.propsData.taskReporterObjs", // 值所在位置
            label: "分派记者", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
        }]
    ]
;

class ViewTasksInput extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};
    id = uuid();

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            visible: false,//控制弹框显隐
            fid: '',
            information: {
                title: '',
                "taskTopicId": "627eacafa371430001c1ae10",
                place: '',
                sponsor: "",
                contacts: "",
                contactsWay: "",
                content: "",
                medias: [],//选择的媒体
                taskReporterIds: [],
                attachments: []
            },
            propsData: [],//真实数据
            taskId: props.id,
        }

    }

    componentDidMount() {
        this.getPropsData()
    }

    getPropsData = () => {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + this.state.taskId,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    let propsData = data;
                    this.setState({
                        propsData
                    })
                }
            }
        });
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.taskId !== nextProps.id) {
            this.setState({taskId: nextProps.id}, () => {
                this.getPropsData()
            })
        }
    }

    render() {
        let id = `a-${this.id}-modal`;
        return (
            <div className={'checkTask'} style={{padding: '0px 20px'}}>
                <div id={id}>
                    {
                        config && config.length && config.map((item, index) => {
                            return (
                                <div key={index} style={{
                                    display: item && item.length > 1 ? "flex" : '',
                                    justifyContent: item && item.length > 1 ? "space-between" : '',
                                    marginBottom: 0
                                }}>{
                                    item.map((componentItem, _index) => {
                                        return this.renderItem(componentItem, _index, index)
                                    })}
                                </div>
                            )
                        })
                    }
                </div>
                <style>{`
                            #${id} .ant-form-item{
                                margin-bottom:0px !important
                            }
                            #${id} .ant-form-item-label{
                                width: ${config.labelWidth || 80}px;
                                vertical-align: top;
                                height:40px;
                            }
                            #${id} .ant-form-item-label label{
                                color:rgba(0, 0, 0, 0.45)
                            }
                            #${id} .ant-form-item .ant-form-item-control-wrapper .ant-form-item-control{
                                line-height: '' !important;
                            }

                `}</style>
            </div>
        );
    }

    renderItem = (componentItem, _index, index) => {
        let ItemComponent = null;
        try {
            ItemComponent = require(`../../../Interview/components/viewBtn/${componentItem.componentType}.js`).default;
        } catch (e) {
            console.log(e.toString())
        }
        let value = componentItem.value;
        let callBack = (val) => {
            this.onInformationChange({code: value, val})
        };
        let getValue = componentItem.getValue || value;
        let show = componentItem.show ? eval(componentItem.show) : false;
        let type = componentItem.type ? componentItem.type : '';
        let itemValue;
        if (getValue.indexOf(',') > -1) {
            try {
                itemValue = [eval(eval(getValue.split(','))[0]), eval(eval(getValue.split(','))[1])];
            } catch (e) {
                console.log(e.toString())
            }
        } else {
            itemValue = eval(getValue);
        }


        return (
            <ItemComponent
                key={index + "_" + _index}
                type={type}
                {...componentItem}
                itemValue={itemValue}
                show={show}
                callBack={callBack}
            />

        );
    };

    onInformationChange = ({code, val, setState = false}) => {
        if (code.indexOf(",") > -1) {
            let arr = code.split(",");
            arr.forEach((item, i) => {
                this.evalFun({code: item, val: val[i]});
            })
        } else {
            this.evalFun({code: code, val: val});
        }
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({});
        }
    };

    evalFun = ({code, val}) => {
        try {
            eval(`${code}=val`);
        } catch (e) {
            console.log(e.toString())
        }
    };

}

export default ViewTasksInput;